// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewListing-container-sUPB7 {
  width: 100%;
  max-width: 1274px;
  margin: 0 auto;
  padding: 0 15px;
}

.ViewListing-horizontalLineThrough-zQ0oL {
  position: relative;
  display: block;
  border-bottom: 1px solid var(--primary-border);
}

.ViewListing-positionSticky-dhZW3 {
  position: sticky !important;
  top: 80px;
}

.ViewListing-zPanel-PnUc4 {
  z-index: 5;
  left: 0px;
  right: 0px;
  background: var(--primary-white-bg);
  width: 100% !important;
}

.ViewListing-active-Re8WI,
.ViewListing-active-Re8WI:hover,
.ViewListing-active-Re8WI:focus {
  color: var(--common-link-color) !important;
  text-decoration: none !important;
  cursor: pointer;
  font-weight: 600;
}

.ViewListing-topmenu-LPRVu {
  padding: 20px 0px;
  margin: 0px 15px;
  list-style: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-bottom: 1px solid var(--primary-border);
}

.ViewListing-listDot-VVGKv {
  position: relative;
  margin-right: 30px;
  cursor: pointer;
}

.ViewListing-listDot-VVGKv:after {
  content: '';
  background-color: var(--common-text-color);
  border-radius: 50%;
  vertical-align: middle;
  width: 6px;
  height: 6px;
  position: absolute;
  top: 10px;
  right: -15px;
}

.ViewListing-listDot-VVGKv:last-child:after {
  display: none;
}

.ViewListing-stickyBookButton-FmtQM {
  display: none;
}

.ViewListing-filtersFooter-ATPVv {
  position: fixed !important;
  bottom: 0px !important;
  left: 0px !important;
  right: 0px !important;
  z-index: 4;
}

.ViewListing-filtersContainer-IdsfO {
  background-color: var(--primary-white-bg) !important;
  padding: 16px !important;
  z-index: 5 !important;
  border-top: 1px solid var(--primary-border) !important;
  -webkit-box-shadow: 0px 0px 4px 1px var(--primary-border);
          box-shadow: 0px 0px 4px 1px var(--primary-border);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.ViewListing-bookItPrice-Auv2w {
  word-wrap: break-word;
}

.ViewListing-instantIcon-RYNzP {
  color: var(--instantBookIcon-Color);
  height: 22px;
  width: 22px;
}

.ViewListing-displayFlex-y52Xz {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.ViewListing-starImageMargin-byQzs {
  margin-right: 3px;
}

.ViewListing-similarPadding-YMK_A {
  padding: 0px;
}

.ViewListing-dotSection-kw7G5 {
  position: relative;
  padding-left: 14px;
}

.ViewListing-dotSection-kw7G5::before {
  content: '';
  position: absolute;
  top: 8px;
  left: 5px;
  width: 4px;
  height: 4px;
  background-color: var(--common-text-color);
  border-radius: 50%;
}

.ViewListing-listingIntroMarginTop-UNz80 {
  margin-top: 16px;
}

.ViewListing-listingMarginTop-gz9X9 {
  margin-top: 43px;
  padding: 0;
}

.ViewListing-overFlowHidden-OaKIw {
  overflow: hidden;
}

.ViewListing-nonActive-bqj9f {
  display: none;
}

@media screen and (max-width: 1199px) {
  .ViewListing-stickyBookButton-FmtQM {
    display: block;
  }

  .ViewListing-similarPadding-YMK_A {
    padding: 0px 5px;
  }

  .ViewListing-hideCalendar-Rb0VI {
    display: none;
  }
}

@media (max-width:1023px) and (min-width:768px) {
  .ViewListing-zPanel-PnUc4 {
    z-index: 3;
  }
}

@media screen and (max-width: 991px) {
  .ViewListing-sliderMargin-VkfEI {
    margin-bottom: 50px;
  }
}

@media screen and (max-width: 767px) {
  .ViewListing-boxContainer-HTfCr {
    width: 100% !important;
  }

  .ViewListing-webDevice-mghDG {
    display: block !important;
  }

  .ViewListing-filtersFooter-ATPVv {
    width: 100%;
    display: block;
  }

}`, "",{"version":3,"sources":["webpack://./src/routes/viewListing/ViewListing.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,sBAAsB;AACxB;;AAGA;;;EAGE,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,8CAA8C;AAChD;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,oDAAoD;EACpD,wBAAwB;EACxB,qBAAqB;EACrB,sDAAsD;EACtD,yDAAiD;UAAjD,iDAAiD;EACjD,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;AACpB;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;AAEF","sourcesContent":[".container {\n  width: 100%;\n  max-width: 1274px;\n  margin: 0 auto;\n  padding: 0 15px;\n}\n\n.horizontalLineThrough {\n  position: relative;\n  display: block;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.positionSticky {\n  position: sticky !important;\n  top: 80px;\n}\n\n.zPanel {\n  z-index: 5;\n  left: 0px;\n  right: 0px;\n  background: var(--primary-white-bg);\n  width: 100% !important;\n}\n\n\n.active,\n.active:hover,\n.active:focus {\n  color: var(--common-link-color) !important;\n  text-decoration: none !important;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.topmenu {\n  padding: 20px 0px;\n  margin: 0px 15px;\n  list-style: none;\n  display: flex;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n\n.listDot {\n  position: relative;\n  margin-right: 30px;\n  cursor: pointer;\n}\n\n.listDot:after {\n  content: '';\n  background-color: var(--common-text-color);\n  border-radius: 50%;\n  vertical-align: middle;\n  width: 6px;\n  height: 6px;\n  position: absolute;\n  top: 10px;\n  right: -15px;\n}\n\n.listDot:last-child:after {\n  display: none;\n}\n\n.stickyBookButton {\n  display: none;\n}\n\n.filtersFooter {\n  position: fixed !important;\n  bottom: 0px !important;\n  left: 0px !important;\n  right: 0px !important;\n  z-index: 4;\n}\n\n.filtersContainer {\n  background-color: var(--primary-white-bg) !important;\n  padding: 16px !important;\n  z-index: 5 !important;\n  border-top: 1px solid var(--primary-border) !important;\n  box-shadow: 0px 0px 4px 1px var(--primary-border);\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.bookItPrice {\n  word-wrap: break-word;\n}\n\n.instantIcon {\n  color: var(--instantBookIcon-Color);\n  height: 22px;\n  width: 22px;\n}\n\n.displayFlex {\n  display: flex;\n  align-items: center;\n}\n\n.starImageMargin {\n  margin-right: 3px;\n}\n\n.similarPadding {\n  padding: 0px;\n}\n\n.dotSection {\n  position: relative;\n  padding-left: 14px;\n}\n\n.dotSection::before {\n  content: '';\n  position: absolute;\n  top: 8px;\n  left: 5px;\n  width: 4px;\n  height: 4px;\n  background-color: var(--common-text-color);\n  border-radius: 50%;\n}\n\n\n.listingIntroMarginTop {\n  margin-top: 16px;\n}\n\n.listingMarginTop {\n  margin-top: 43px;\n  padding: 0;\n}\n\n.overFlowHidden {\n  overflow: hidden;\n}\n\n.nonActive {\n  display: none;\n}\n\n@media screen and (max-width: 1199px) {\n  .stickyBookButton {\n    display: block;\n  }\n\n  .similarPadding {\n    padding: 0px 5px;\n  }\n\n  .hideCalendar {\n    display: none;\n  }\n}\n\n@media (max-width:1023px) and (min-width:768px) {\n  .zPanel {\n    z-index: 3;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .sliderMargin {\n    margin-bottom: 50px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .boxContainer {\n    width: 100% !important;\n  }\n\n  .webDevice {\n    display: block !important;\n  }\n\n  .filtersFooter {\n    width: 100%;\n    display: block;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ViewListing-container-sUPB7`,
	"horizontalLineThrough": `ViewListing-horizontalLineThrough-zQ0oL`,
	"positionSticky": `ViewListing-positionSticky-dhZW3`,
	"zPanel": `ViewListing-zPanel-PnUc4`,
	"active": `ViewListing-active-Re8WI`,
	"topmenu": `ViewListing-topmenu-LPRVu`,
	"listDot": `ViewListing-listDot-VVGKv`,
	"stickyBookButton": `ViewListing-stickyBookButton-FmtQM`,
	"filtersFooter": `ViewListing-filtersFooter-ATPVv`,
	"filtersContainer": `ViewListing-filtersContainer-IdsfO`,
	"bookItPrice": `ViewListing-bookItPrice-Auv2w`,
	"instantIcon": `ViewListing-instantIcon-RYNzP`,
	"displayFlex": `ViewListing-displayFlex-y52Xz`,
	"starImageMargin": `ViewListing-starImageMargin-byQzs`,
	"similarPadding": `ViewListing-similarPadding-YMK_A`,
	"dotSection": `ViewListing-dotSection-kw7G5`,
	"listingIntroMarginTop": `ViewListing-listingIntroMarginTop-UNz80`,
	"listingMarginTop": `ViewListing-listingMarginTop-gz9X9`,
	"overFlowHidden": `ViewListing-overFlowHidden-OaKIw`,
	"nonActive": `ViewListing-nonActive-bqj9f`,
	"hideCalendar": `ViewListing-hideCalendar-Rb0VI`,
	"sliderMargin": `ViewListing-sliderMargin-VkfEI`,
	"boxContainer": `ViewListing-boxContainer-HTfCr`,
	"webDevice": `ViewListing-webDevice-mghDG`
};
module.exports = ___CSS_LOADER_EXPORT___;
